import axios from "axios";
import { API_BASE_URL } from "@/utils/api";
import { getToken } from "@/utils/authHelpers";
import { StudyDataType } from "@/types/apiTypes";

export const associateStudyToProjectApi = async (
  study: StudyDataType,
  projectId: string,
): Promise<void> => {
  const token = await getToken();
  if (!token) throw new Error("Authorization token is required");

  await axios.post(
    `${API_BASE_URL}/projects/${projectId}/studies/${study.id}`,
    {},
    { headers: { Authorization: `Bearer ${token}` } },
  );
};
